import type * as React from "react";

type Props = {
	/** Eyebrow label, e.g. "DIEET". */
	label: string;
	/** Optional right-aligned control or hint (e.g. "Alle keukens"). */
	action?: React.ReactNode;
	children: React.ReactNode;
	/** `wrap` for chip clouds, `row` for segmented controls. */
	layout?: "wrap" | "row";
};

export function FilterGroup({
	label,
	action,
	children,
	layout = "wrap",
}: Props) {
	return (
		<div className="flex flex-col gap-2.5">
			<div className="flex items-baseline justify-between">
				<div className="text-[11px] font-bold uppercase tracking-[0.06em] text-[var(--content-muted)]">
					{label}
				</div>
				{action}
			</div>
			<div
				className={layout === "row" ? "flex gap-1.5" : "flex flex-wrap gap-2"}
			>
				{children}
			</div>
		</div>
	);
}
